export default __webpack_public_path__ + "static/media/splashScreen_dark.5d758ced.gif";